module.exports = __webpack_public_path__ + "img/人力资源.e7753865.png";